import React from "react";
import { COLORS } from "../../constants/colors";
import { useSelector } from "react-redux";

const steps = [
  "Current Situation",
  "Interest & Reason",
  "Personal Information",
  "Education & Professional",
  "Skills & Competencies",
  "Documents Upload",
];

const ProgressBar = () => {
  const { currentStep } = useSelector((state) => state.profileForm);
  const total = steps.length;
  const percent = Math.round((currentStep / total) * 100);
  const title = steps[currentStep - 1];

  return (
    <div className="mb-6">
      <div className="mb-2">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
          <h2 className="font-semibold text-gray-800 text-base sm:text-xl">
            <span className="hidden sm:inline">Step {currentStep} of {total}: {title}</span>
            <span className="sm:hidden">Step {currentStep}/{total}</span>
          </h2>
          <span className="text-xs sm:text-sm text-gray-600">{percent}% Complete</span>
        </div>
        <div className="sm:hidden text-xs text-gray-500 truncate">{title}</div>
      </div>
      <div
        className="w-full bg-gray-200 rounded-full h-1.5 sm:h-2"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <div
            className="h-1.5 sm:h-2 rounded-full transition-all duration-300"
            style={{ 
              backgroundColor: COLORS.purple,
              width: `${percent}%` 
            }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;
